export default "__VITE_ASSET__CEGxBIFV__"